import { createReducer, on } from '@ngrx/store';
import { setWithIOFRelatedAction } from './withIOF.actions';



export const initialState = true;

export const withIOFReducer = createReducer(
  initialState,
  on(setWithIOFRelatedAction, (state, { withIOFRelated }) => withIOFRelated)
);
